import React from 'react';
import upgradeBannerLeft from 'ck-website/graphics/upgrades/upgrade-banner-left.svg';
import upgradeBannerRight from 'ck-website/graphics/upgrades/upgrade-banner-right.svg';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import classnames from 'classnames';
import { lang } from './lang';

import './index.less';

interface Props {
	isCompact?: boolean;
}

export const UpgradePlanBanner: React.SFC<Props> = ({ isCompact }) => (
	<div className={classnames('UpgradePlanBanner', isCompact && 'UpgradePlanBanner--compact')}>
		<div
			className="UpgradePlanBanner__left"
			style={{
				backgroundImage: `url(${upgradeBannerLeft})`
			}}
		/>
		<div className="UpgradePlanBanner__text">
			<div className="UpgradePlanBanner__title">{lang.TITLE}</div>
			<div className="UpgradePlanBanner__subtitle">{lang.SUBTITLE}</div>
		</div>
		<div className="UpgradePlanBanner__button">
			<RoundButton
				text={lang.CTA}
				size="medium"
				colour="yellow"
				handleClick={() => CK.frame.navigate('/plans')}
			/>
		</div>
		<div
			className="UpgradePlanBanner__right"
			style={{
				backgroundImage: `url(${upgradeBannerRight})`
			}}
		/>
	</div>
);
